import { render, staticRenderFns } from "./PageNotFound-Desktop.vue?vue&type=template&id=9fe98d72&scoped=true&"
import script from "./PageNotFound-Desktop.vue?vue&type=script&lang=js&"
export * from "./PageNotFound-Desktop.vue?vue&type=script&lang=js&"
import style0 from "./PageNotFound-Desktop.vue?vue&type=style&index=0&id=9fe98d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe98d72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
